const practiceUi = {
  en: {
    cardGuidance: {
      flip: 'Flip', knowAnswer: 'I know the answer', repeat: 'Tap to repeat +1', autoRepeat: 'Auto repeat',
      recallPurpose: 'Try answering. Flip the card to check the answer.',
      answerPurpose: 'Compare your answer. Choose O if it matches, or X if it differs.',
      repeatPurpose: 'Read the answer and complete the required repetitions.',
    },
    reviewTraining: {
      title: 'Review training', prompt: 'Bring your completed sentences back to mind.',
      limits: 'Up to 100 cards · 30 minutes · Stop anytime',
      empty: 'Complete a non-Reading card to start review training.',
      preparing: 'Preparing…', start: 'Start review', end: 'End training',
      sessionTime: 'Training time', endTitle: 'End review training?',
      endMessage: 'Your repetitions, points and review dates will be saved.',
      keepTraining: 'Keep training', saving: 'Saving review…',
      complete: 'Review complete', reasonCards: 'You reviewed all the selected cards.',
      reasonTime: 'Your 30 minutes of review are complete.', reasonManual: 'You ended this review.',
      success: 'Passed', fail: 'Needed repetition', repeats: 'Repetitions', points: 'Points',
      back: 'Back', correct: 'Remembered!', needsRepeat: 'Let’s repeat this one.',
      sceneUnavailable: 'No NPC Scene is available right now. Please try again later.',
      startFailed: 'Review could not start. Please try again.',
      dailyLimit: 'You have used today’s workout starts. Try again tomorrow.',
      checkpointFailed: 'Progress could not be saved yet. We’ll retry automatically; end training to save again.',
      saveFailedTitle: 'Review has not been saved',
      saveFailed: 'Your results are still here. Check your connection and retry before leaving.',
      retrySave: 'Retry saving',
    },
    encounter: {
      challengeTitle: 'NPC Challenge',
      challengeMessage: 'An NPC will quiz you on cards you’ve completed. Will you accept the challenge?',
      accept: 'Accept challenge',
      later: 'Maybe later',
      cardPrompt: 'How about this card? {index} / {total}',
      timerLabel: 'Time remaining',
      timeOut: 'Time out',
      repeatLabel: 'Repeat progress',
      repeatProgress: 'Repeat {count}/{total}',
      remembered: 'I got it right', practiceAgain: 'Practice again',
      answerViewedBonus: 'Answer', repeatBonus: 'Repeat',
    },
    modeBadge: { fluency: 'Fluency', core: 'Core', quick: 'Quick' },
    userHints: {
      '시제': 'Tense', '의역이다': 'Not literal', '복잡해': 'Tricky',
      '쉽게생각': 'Think simple', '길다': 'Long', '앞': 'Ahead',
      '뒤': 'Behind', '속지마': "Don't be fooled", '아니다': 'Not this',
      '시제일치': 'Tense agreement', '단수복수': 'Singular / plural',
      '생소하다': 'Unfamiliar', '짧다': 'Short', '앞부분': 'Beginning',
      '중간부분': 'Middle', '뒷부분': 'Ending', '조심해': 'Beware',
    },
    scene: { narrator: 'Narrator', character: 'Scene character' },
    navigation: { title: 'Practice in progress', message: 'Browser Back is disabled during practice. Use End Practice to save and leave.' },
    end: { title: 'End Practice?', message: 'Your progress will be saved and this training session will finish.', confirm: 'End Practice', cancel: 'Keep Training' },
    delete: { title: 'Delete Flash Card?', message: 'This card will be removed from the drill.', confirm: 'Delete', cancel: 'Keep' },
    completion: {
      timeTitle: '30 Minutes Complete!', timeMessage: 'Congratulations! You completed a full 30-minute training session.',
      setTitle: 'Training Set Complete!', setMessage: 'No more cards are ready right now. Add new notes or come back when more cards are due.',
      minutes: "You've been training for {count} minutes", cards: 'Practiced {count} cards!',
      manualTitle: 'Already Know It!', manualMessage: 'You reached Grade 5. This card is finished.',
      scoreTitle: 'Goal Achieved!', scoreMessage: 'You reached the practice goal. This card is finished.',
      earlyTitle: 'Fully Mastered!', earlyMessage: 'You passed every test in a row. Smart, sharp, unforgettable.',
    },
    coaching: { title: 'Coaching Time', message: 'Keep going! One speaking rep at a time.', trainer: 'Trainer {trainer}, practice {practice}' },
    summary: {
      title: 'Practice Session Complete!', empty: 'No session data available.',
      queueExhausted: 'All ready cards were practiced. Add a new note or come back when more cards are due.',
      infinity: 'Infinity Mode', cards: 'Cards Practiced', batches: 'Batches Completed',
      timePracticed: 'Time Practiced', points: 'Points Earned', grade: 'Average Grade',
      records: 'Practice records', practiceTime: 'Practice Time', cardsStudied: 'Cards Studied',
      session: 'This Session', today: 'Today', repeats: 'Repeat Count', noCards: 'No cards were practiced during this session.',
      minutes: '{count}m', unavailable: 'N/A',
    },
    tournament: {
      enter: 'Enter Tournament', checking: 'Checking tournament...', soon: 'soon',
      aliveAlt: 'Still in the tournament', eliminatedAlt: 'Eliminated from the tournament', inviteAlt: 'Tournament invitation',
      loading: 'The tournament board is loading.', scheduled: 'Next competition is {month}; signup opens {date}.',
      signup: 'Signup is open for {month}; {count}/32 players have entered.',
      active: 'Today is {phase} - Day {day}/7.', completed: 'Final results are ready for {month}.',
      cancelled: 'This month was cancelled because no player entered.', current: 'Current tournament: {month}.',
      notAttending: 'Please look forward to next competition!',
      eliminated: 'You are out this time. Check the results and prepare for the next competition.',
      entered: 'Your entry is ready. Check the fighter list before battle starts.',
      final: 'The champion has been crowned. Check the final results.', alive: 'You are still in. Keep your focus for the next match.',
      error: 'Tournament information could not be loaded.', retry: 'You can still enter the tournament page and retry there.',
    },
  },
  ko: {
    cardGuidance: {
      flip: '뒤집기', knowAnswer: '정답을 알아요', repeat: '터치하여 반복 +1', autoRepeat: '일괄 반복',
      recallPurpose: '맞춰보세요. 답을 확인하려면 카드를 뒤집어 주세요',
      answerPurpose: '이 답변과 비교하세요. 맞다면 O, 다르다면 X를 선택하세요.',
      repeatPurpose: '답을 읽고, 반복 횟수를 채워주세요',
    },
    reviewTraining: {
      title: '복습 훈련', prompt: '익힌 문장을 다시 꺼내볼까요?',
      limits: '최대 100장 · 30분 · 언제든 종료',
      empty: 'Reading 외의 카드를 학습 완료하면 복습 훈련을 시작할 수 있어요.',
      preparing: '준비 중…', start: '복습 시작', end: '훈련 종료',
      sessionTime: '훈련 시간', endTitle: '복습 훈련을 끝낼까요?',
      endMessage: '지금까지의 반복 횟수, 포인트와 복습일을 저장합니다.',
      keepTraining: '계속 훈련', saving: '복습 기록 저장 중…',
      complete: '복습 완료', reasonCards: '선택된 카드를 모두 복습했어요.',
      reasonTime: '30분 복습을 마쳤어요.', reasonManual: '이번 복습을 종료했어요.',
      success: '성공', fail: '반복 필요', repeats: '반복 횟수', points: '포인트',
      back: '돌아가기', correct: '기억하고 있어요!', needsRepeat: '이 문장은 다시 반복해봐요.',
      sceneUnavailable: '지금 재생할 NPC Scene이 없어요. 잠시 후 다시 시도해 주세요.',
      startFailed: '복습 훈련을 시작하지 못했어요. 다시 시도해 주세요.',
      dailyLimit: '오늘의 훈련 시작 횟수를 모두 사용했어요. 내일 다시 시작해 주세요.',
      checkpointFailed: '아직 기록을 저장하지 못했어요. 자동으로 재시도하며, 훈련 종료 시에도 저장합니다.',
      saveFailedTitle: '복습 기록이 아직 저장되지 않았어요',
      saveFailed: '결과는 이 화면에 남아 있어요. 연결 상태를 확인하고 나가기 전에 다시 저장해 주세요.',
      retrySave: '다시 저장',
    },
    encounter: {
      challengeTitle: 'NPC 도전',
      challengeMessage: 'NPC가 학습을 마친 카드로 질문해요. 도전을 받아들일까요?',
      accept: '도전 수락',
      later: '다음에',
      cardPrompt: '이 카드는 어때? {index} / {total}',
      timerLabel: '남은 시간',
      timeOut: '시간 초과',
      repeatLabel: '반복 진행',
      repeatProgress: '반복 {count}/{total}',
      remembered: '맞았어요', practiceAgain: '다시 연습',
      answerViewedBonus: '답 확인', repeatBonus: '반복',
    },
    modeBadge: { fluency: '유창성', core: '기본', quick: '간이' },
    userHints: {
      '시제': '시제', '의역이다': '의역이다', '복잡해': '복잡해',
      '쉽게생각': '쉽게생각', '길다': '길다', '앞': '앞',
      '뒤': '뒤', '속지마': '속지마', '아니다': '아니다',
      '시제일치': '시제일치', '단수복수': '단수복수', '생소하다': '생소하다',
      '짧다': '짧다', '앞부분': '앞부분', '중간부분': '중간부분',
      '뒷부분': '뒷부분', '조심해': '조심해',
    },
    scene: { narrator: '안내', character: '장면 등장인물' },
    navigation: { title: '훈련 중입니다', message: '훈련 중에는 브라우저 뒤로가기를 사용할 수 없습니다. 기록을 저장하고 나가려면 훈련 끝내기를 눌러 주세요.' },
    end: { title: '훈련을 끝낼까요?', message: '진행한 기록을 저장하고 이번 훈련을 끝냅니다.', confirm: '훈련 끝내기', cancel: '계속 훈련' },
    delete: { title: '카드를 삭제할까요?', message: '이 카드를 훈련에서 삭제합니다.', confirm: '삭제', cancel: '유지' },
    completion: {
      timeTitle: '30분 훈련 완료!', timeMessage: '축하합니다! 30분 훈련을 모두 마쳤습니다.',
      setTitle: '훈련 세트 완료!', setMessage: '지금 훈련할 수 있는 카드를 모두 마쳤습니다. 새 노트를 추가하거나 다음 복습 때 다시 만나요.',
      minutes: '{count}분 동안 훈련했어요', cards: '카드 {count}장을 훈련했어요!',
      manualTitle: '이미 알고 있어요', manualMessage: '5등급에 도달해 이 카드의 학습을 완료했습니다.',
      scoreTitle: '목표 달성', scoreMessage: '훈련 목표를 달성해 이 카드의 학습을 완료했습니다.',
      earlyTitle: '마스터!', earlyMessage: '모든 시험을 연속으로 통과했어요. 표현이 기억에 단단히 자리 잡았네요.',
    },
    coaching: { title: '코칭 시간', message: '한 문장씩 소리 내어 말하며 계속해 봐요.', trainer: '트레이너 {trainer}, 훈련 {practice}' },
    summary: {
      title: '훈련을 마쳤어요!', empty: '표시할 훈련 기록이 없습니다.',
      queueExhausted: '지금 훈련할 수 있는 카드를 모두 마쳤습니다. 새 노트를 추가하거나 다음 복습 때 다시 만나요.',
      infinity: '무한 모드', cards: '훈련한 카드', batches: '완료한 세트',
      timePracticed: '훈련 시간', points: '획득 포인트', grade: '평균 등급',
      records: '훈련 기록', practiceTime: '훈련 시간', cardsStudied: '학습한 카드',
      session: '이번 훈련', today: '오늘', repeats: '반복 횟수', noCards: '이번 훈련에서 학습한 카드가 없습니다.',
      minutes: '{count}분', unavailable: '기록 없음',
    },
    tournament: {
      enter: '세계 대회 입장', checking: '세계 대회 확인 중...', soon: '곧',
      aliveAlt: '세계 대회 도전 중', eliminatedAlt: '세계 대회 탈락', inviteAlt: '세계 대회 초대',
      loading: '세계 대회 정보를 불러오고 있습니다.', scheduled: '{month} 대회 참가 신청은 {date}부터 시작합니다.',
      signup: '{month} 대회 참가 신청 중입니다. 현재 {count}/32명이 참가했습니다.',
      active: '오늘은 {phase}, 대회 {day}/7일차입니다.', completed: '{month} 대회의 최종 결과가 나왔습니다.',
      cancelled: '참가자가 없어 이번 달 대회가 취소되었습니다.', current: '현재 대회: {month}.',
      notAttending: '다음 대회를 기대해 주세요!',
      eliminated: '이번 대회에서는 탈락했습니다. 결과를 확인하고 다음 대회를 준비해 보세요.',
      entered: '참가 신청을 마쳤습니다. 경기가 시작되기 전에 참가자 목록을 확인해 보세요.',
      final: '우승자가 결정되었습니다. 최종 결과를 확인해 보세요.', alive: '도전이 이어지고 있습니다. 다음 경기를 준비해 보세요.',
      error: '세계 대회 정보를 불러오지 못했습니다.', retry: '세계 대회 화면으로 이동해 다시 시도할 수 있습니다.',
    },
  },
};

export default practiceUi;
